// import axios from 'axios';
// import config from './environment';
// import { getAuth } from "firebase/auth";

// const auth = getAuth();

// let tokenPromise = null;

// export const getFreshToken = async () => {
//  if (auth.currentUser) {
//    return await auth.currentUser.getIdToken(true); // Force refresh
//  }
//  return null;
// };


//  const UpdateToken = async (deviceToken) => {
//  try {
//    const response = await axiosInstance.post(
//    "user.php?method=update_device_token",
//    { device_token: deviceToken } // ✅ Send device_token in request body
//    );
//    console.log("Token Updated:", response.data);
//  } catch (error) {
//    console.error(
//    "Update Token Failed:",
//    error.response?.data || error.message
//    );
//  }
//   };
// const axiosInstance = axios.create({
//  baseURL:`${config.baseUrl}${config.apiServer}`
// });

// const useJWT = async (config) => {
//  let firebaseToken = localStorage.getItem('idToken');
//  const user = auth.currentUser;

//  if (!firebaseToken && user) {
//    if(!tokenPromise)
//    {
//      tokenPromise=user.getIdToken().then((token)=>{
//        tokenPromise=null;
//        return token;
//      })
//    }
//    firebaseToken = await tokenPromise;
//    if (firebaseToken) {
//      localStorage.setItem("idToken", firebaseToken);
//    }
//  }
//  if(firebaseToken)
//  {

//  config.headers['Authorization'] =` Bearer ${firebaseToken}`;
//  }
  
//  return config;
// }
// axiosInstance.interceptors.request.use(useJWT);

// axiosInstance.interceptors.response.use(
//  (response) => response,
//  async (error) => {
//    const originalRequest = error.config;
//    if (error.response?.status === 401 &&  !originalRequest._retry) {
//      originalRequest._retry = true;
//      const newToken = await getFreshToken(); // Refresh token on 401
//      if (newToken) {
//        localStorage.setItem("idToken", newToken); // ✅ Store new token
//        await UpdateToken(newToken); // ✅ Send updated token to server
//        axiosInstance.defaults.headers.common["Authorization"]=`Bearer ${newToken}`
//        originalRequest.headers["Authorization"]=`Bearer ${newToken}`
//        return axiosInstance(originalRequest);
//      }
//    }
//    return Promise.reject(error);
//  }
// );

// export default axiosInstance;  


import axios from 'axios';
import config from './environment';
import { getAuth } from "firebase/auth";

const auth = getAuth();

const axiosInstance = axios.create({
  baseURL: `${config.baseUrl}${config.apiServer}`,
});

const getFreshToken = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken(true);
      if (token?.split(".").length === 3) {
        localStorage.setItem("idToken", token);
        return token;
      } else {
        console.error("Invalid JWT format from Firebase");
      }
    }
  } catch (error) {
    console.error("Error getting fresh token:", error);
  }
  return null;
};

const updateDeviceToken = async (token) => {
  if (!token || token.split(".").length !== 3) {
    console.error("Token format invalid for updateDeviceToken:", token);
    return;
  }

  try {
    const response = await axiosInstance.post("user.php?method=update_device_token", {
      device_token: token
    });
    console.log("Device token updated:");
  } catch (error) {
    console.error("Device token update failed:", error.response?.data || error.message);
  }
};

// Add token to request
axiosInstance.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("idToken");

  if (!token || token.split(".").length !== 3) {
    token = await getFreshToken();
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
}, (error) => Promise.reject(error));

// Handle expired tokens
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const newToken = await getFreshToken();

      if (newToken) {
        await updateDeviceToken(newToken);
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        console.error("Unable to refresh token. User might need to log in again.");
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;


// import axios from 'axios';
// import config from './environment';
// import { getAuth } from "firebase/auth";

// const auth = getAuth();

// export const getFreshToken = async () => {
//  if (auth.currentUser) {
//    return await auth.currentUser.getIdToken(true); // Force refresh
//  }
//  return null;
// };


//  const UpdateToken = async (deviceToken) => {
//  try {
//    const response = await axiosInstance.post(
//    "user.php?method=update_device_token",
//    { device_token: deviceToken } // ✅ Send device_token in request body
//    );
//    console.log("Token Updated:", response.data);
//  } catch (error) {
//    console.error(
//    "Update Token Failed:",
//    error.response?.data || error.message
//    );
//  }
//   };
// const axiosInstance = axios.create({
//  baseURL: `${config.baseUrl}${config.apiServer}`
// });

// const useJWT = async (config) => {
//  let firebaseToken = localStorage.getItem('idToken');

//  if (!firebaseToken) {
//    firebaseToken = await getFreshToken();
//    if (firebaseToken) {
//      localStorage.setItem("idToken", firebaseToken);
//    }
//  }

//  config.headers['Authorization'] = 'Bearer ' + firebaseToken
//  return config;
// }

// axiosInstance.interceptors.request.use(useJWT);

// axiosInstance.interceptors.response.use(
//  (response) => response,
//  async (error) => {
//    console.log("error",error.config)
//    const originalRequest = error.config;
//    if (error.response?.status === 401 &&  !originalRequest._retry) {
//      originalRequest._retry = true;
//      const newToken = await getFreshToken(); // Refresh token on 401
//      if (newToken) {
//        localStorage.setItem("idToken", newToken); // ✅ Store new token
//        await UpdateToken(newToken); // ✅ Send updated token to server
//        console.log("originalrequest",originalRequest)
//        axiosInstance.defaults.headers.common["Authorization"]=`Bearer ${newToken}`
//        originalRequest.headers["Authorization"]=`Bearer ${newToken}`
//        return axiosInstance(originalRequest);
//      }
//    }
//    return Promise.reject(error);
//  }
// );

// export default axiosInstance;